import './NotFound.css'
import { Typography } from 'components/UI/atoms'

const Blue = '/images/planets/Blue.png'
const Green = '/images/planets/Green.png'
// const Background = '/images/planets/Background.png'

const NotFoundPage = () => (
	<div class='not-found-container flex h-screen w-full flex-col items-center justify-center bg-black'>
		<div class='relative'>
			<h1 class='text-whitea font-wix text-[8.125rem] font-extrabold leading-[10.235rem]'>
				Oops!
			</h1>
			<img
				alt='Green-planet'
				class='absolute left-[-25px] top-[-20px]'
				height={78}
				loading='lazy'
				src={Green}
				width={78}
			/>

			<Typography
				class='mt-8'
				color='text-black-100'
				text="That's an error"
				variant='h1'
			/>

			<Typography
				class='mt-4'
				color='text-black-100'
				text='The requested URL was not found on this server.'
				variant='text1'
			/>

			<Typography
				class='mt-10'
				color='text-black-400'
				text='Error: 404'
				variant='text1'
			/>
		</div>

		<img
			alt='Blue-planet'
			class='absolute left-6 top-10'
			height={36}
			loading='lazy'
			src={Blue}
			width={36}
		/>
	</div>
)

export { NotFoundPage }
